/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StepConstraintDto } from './StepConstraintDto';
import {
    StepConstraintDtoFromJSON,
    StepConstraintDtoFromJSONTyped,
    StepConstraintDtoToJSON,
    StepConstraintDtoToJSONTyped,
} from './StepConstraintDto';

/**
 * 
 * @export
 * @interface CreateQuestionCommand
 */
export interface CreateQuestionCommand {
    /**
     * Parent questionnaire ID
     * @type {string}
     * @memberof CreateQuestionCommand
     */
    questionnaireId: string;
    /**
     * Question type ID
     * @type {string}
     * @memberof CreateQuestionCommand
     */
    questionTypeId: string;
    /**
     * Question key/code
     * @type {string}
     * @memberof CreateQuestionCommand
     */
    key: string;
    /**
     * Question label/text
     * @type {string}
     * @memberof CreateQuestionCommand
     */
    label: string;
    /**
     * Step number in the questionnaire
     * @type {number}
     * @memberof CreateQuestionCommand
     */
    step?: number | null;
    /**
     * Display order of the question
     * @type {number}
     * @memberof CreateQuestionCommand
     */
    displayOrder: number;
    /**
     * Icon key for the question
     * @type {string}
     * @memberof CreateQuestionCommand
     */
    iconKey?: string | null;
    /**
     * Group title for question grouping
     * @type {string}
     * @memberof CreateQuestionCommand
     */
    groupTitle?: string | null;
    /**
     * Whether the question is required
     * @type {boolean}
     * @memberof CreateQuestionCommand
     */
    isRequired?: boolean;
    /**
     * Dependencies for this question
     * @type {Array<StepConstraintDto>}
     * @memberof CreateQuestionCommand
     */
    dependsOn?: Array<StepConstraintDto> | null;
    /**
     * Constraints applied to this question
     * @type {Array<StepConstraintDto>}
     * @memberof CreateQuestionCommand
     */
    constraints?: Array<StepConstraintDto> | null;
    /**
     * Conditions to skip this question
     * @type {Array<StepConstraintDto>}
     * @memberof CreateQuestionCommand
     */
    skipIf?: Array<StepConstraintDto> | null;
}

/**
 * Check if a given object implements the CreateQuestionCommand interface.
 */
export function instanceOfCreateQuestionCommand(value: object): value is CreateQuestionCommand {
    if (!('questionnaireId' in value) || value['questionnaireId'] === undefined) return false;
    if (!('questionTypeId' in value) || value['questionTypeId'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined) return false;
    return true;
}

export function CreateQuestionCommandFromJSON(json: any): CreateQuestionCommand {
    return CreateQuestionCommandFromJSONTyped(json, false);
}

export function CreateQuestionCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateQuestionCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'questionnaireId': json['questionnaireId'],
        'questionTypeId': json['questionTypeId'],
        'key': json['key'],
        'label': json['label'],
        'step': json['step'] == null ? undefined : json['step'],
        'displayOrder': json['displayOrder'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'groupTitle': json['groupTitle'] == null ? undefined : json['groupTitle'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'dependsOn': json['dependsOn'] == null ? undefined : ((json['dependsOn'] as Array<any>).map(StepConstraintDtoFromJSON)),
        'constraints': json['constraints'] == null ? undefined : ((json['constraints'] as Array<any>).map(StepConstraintDtoFromJSON)),
        'skipIf': json['skipIf'] == null ? undefined : ((json['skipIf'] as Array<any>).map(StepConstraintDtoFromJSON)),
    };
}

export function CreateQuestionCommandToJSON(json: any): CreateQuestionCommand {
    return CreateQuestionCommandToJSONTyped(json, false);
}

export function CreateQuestionCommandToJSONTyped(value?: CreateQuestionCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionnaireId': value['questionnaireId'],
        'questionTypeId': value['questionTypeId'],
        'key': value['key'],
        'label': value['label'],
        'step': value['step'],
        'displayOrder': value['displayOrder'],
        'iconKey': value['iconKey'],
        'groupTitle': value['groupTitle'],
        'isRequired': value['isRequired'],
        'dependsOn': value['dependsOn'] == null ? undefined : ((value['dependsOn'] as Array<any>).map(StepConstraintDtoToJSON)),
        'constraints': value['constraints'] == null ? undefined : ((value['constraints'] as Array<any>).map(StepConstraintDtoToJSON)),
        'skipIf': value['skipIf'] == null ? undefined : ((value['skipIf'] as Array<any>).map(StepConstraintDtoToJSON)),
    };
}

